import { IPlotTemperatureRecord } from "@interfaces/IPlot";
import { IProfileQueryOptions } from "@temperature/_models/temperature/IProfileQueryOptions";
import { ITemperatureAlarmRecord } from "@temperature/_models/temperature/ITemperatureAlarmRecord";
import { ITemperatureOutOfBoundsHistory } from "@temperature/_models/temperature/ITemperatureOutOfBoundsHistory";
import { ITemperatureProbeWithTemperatureData } from "@temperature/_models/temperature/ITemperatureProbe";
import { ITemperatureProfile } from "@temperature/_models/temperature/ITemperatureProfile";
import { ITemperatureRecord } from "@temperature/_models/temperature/ITemperatureRecord";
import * as angular from "angular";


export class TemperatureService {

    static $inject = ["$http"];

    constructor(
        private $http: angular.IHttpService
    ) {
    }

    getTemperatureProfiles(invalidateCache = false, queryOptions?: IProfileQueryOptions): angular.IPromise<ITemperatureProfile[]> {
        // Angular version in TemperatureProfileService
        return this
            .$http({
                url: `/api/temperature/profiles`,
                method: "GET",
                cache: true,
                params: { minsToLive: 5, invalidateCache: invalidateCache, queryOptions: queryOptions }
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureProfile[]>) => {
                return result.data;
            });
    }

    saveTemperatureProfile(profile: ITemperatureProfile): angular.IPromise<ITemperatureProfile> {
        // Angular version in TemperatureProfileService
        return this
            .$http({
                url: `/api/temperature/profiles`,
                method: "POST",
                cache: true,
                data: profile
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureProfile>) => {
                return result.data;
            });
    }

    getActiveVehicleTemperatureOutOfBoundsHistories(invalidateCache = false): angular.IPromise<ITemperatureOutOfBoundsHistory[]> {
        // Angular version in TemperatureOutOfBoundsService
        return this
            .$http({
                url: `/api/temperature/outOfBoundsHistories/active`,
                method: "GET",
                cache: true,
                params: {
                    minsToLive: 5,
                    invalidateCache: invalidateCache
                }
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureOutOfBoundsHistory[]>) => {
                return result.data;
            });
    }

    getVehicleTemperatureOutOfBoundsHistories(vehicleId: number, startMoment: moment.Moment, endMoment: moment.Moment, invalidateCache = false): angular.IPromise<ITemperatureOutOfBoundsHistory[]> {
        // Angular version in TemperatureOutOfBoundsService
        return this
            .$http({
                url: `/api/temperature/outOfBoundsHistories`,
                method: "GET",
                cache: true,
                params: {
                    id: vehicleId,
                    start: startMoment.toISOString(),
                    end: endMoment.toISOString(),
                    minsToLive: 5,
                    invalidateCache: invalidateCache
                }
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureOutOfBoundsHistory[]>) => {
                return result.data;
            });
    }

    getVehicleTemperatureOutOfBoundsHistory(historyId: number): angular.IPromise<ITemperatureOutOfBoundsHistory> {
        // Angular version in TemperatureOutOfBoundsService
        return this
            .$http({
                url: `/api/temperature/outOfBoundsHistory/${historyId}`,
                method: "GET"
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureOutOfBoundsHistory>) => {
                return result.data;
            });
    }

    getVehicleTemperatureOutOfBoundsHistoryByAlarmRecord(alarmId: number): angular.IPromise<ITemperatureOutOfBoundsHistory> {
        // Angular version in TemperatureOutOfBoundsService
        return this
            .$http({
                url: `/api/temperature/outOfBoundsHistoryByAlarm/${alarmId}`,
                method: "GET"
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureOutOfBoundsHistory>) => {
                return result.data;
            });
    }

    getAllVehicleTemperatureOutOfBoundsHistories(startMoment: moment.Moment, endMoment: moment.Moment, invalidateCache = false): angular.IPromise<ITemperatureOutOfBoundsHistory[]> {
        // Angular version in TemperatureOutOfBoundsService
        return this
            .$http({
                url: `/api/temperature/outOfBoundsHistories`,
                method: "GET",
                cache: true,
                params: {
                    start: startMoment.toISOString(),
                    end: endMoment.toISOString(),
                    minsToLive: 5,
                    invalidateCache: invalidateCache
                }
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureOutOfBoundsHistory[]>) => {
                return result.data;
            });
    }

    getTemperatureRecord(id: number): angular.IPromise<ITemperatureRecord> {
        // Angular version in TemperatureRecordService
        return this
            .$http({
                url: `/api/temperature/records/${id}`,
                method: "GET",
                cache: true
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureRecord>) => {
                return result.data;
            });
    }

    getTemperatureAlarmRecord(id: number): angular.IPromise<ITemperatureAlarmRecord> {
        // Angular version in TemperatureRecordService
        return this
            .$http({
                url: `/api/temperaturealarm/${id}`,
                method: "GET",
                cache: true
            })
            .then((result: angular.IHttpPromiseCallbackArg<ITemperatureAlarmRecord>) => {
                return result.data;
            });
    }


    mapTemperatureRecordsToProbes(records: IPlotTemperatureRecord[], probes: ITemperatureProbeWithTemperatureData[]) {
        records.sort((a, b) => {
            return new Date(b.Timestamp).getTime() - new Date(a.Timestamp).getTime();
        });

        probes.forEach(probe => {
            probe.records = [];

            records.forEach(record => {
                if (record.TemperatureProbeId === probe.Id) {
                    probe.records.push(record);
                }
            });

            probe.latestRecord = records.find(rec => rec.TemperatureProbeId === probe.Id)
        });

        return probes;
    }
}
